package com.appsyde.shared.modules.account.domain.usecase

import com.appsyde.shared.modules.account.domain.model.CheckoutSession
import com.appsyde.shared.modules.account.domain.repository.AccountRepository

class CreateCheckoutSessionUseCase(
    private val accountRepository: AccountRepository
) {
    suspend operator fun invoke(): CheckoutSession? = accountRepository.createCheckoutSession()
}
